import './App.css';
import sensorService from './services/sensorService.ts'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";

function App() {
  const [data, setData] = useState(null);
  const [lastMeasured, setLastMeasured] = useState(0);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  const fetchTemperature = useCallback(async () => {
    try {
      setError(null);
      const resp = await sensorService.GetTemperature();
      setData(resp);
    } catch (err) {
      setError(t('fetchError'));
    }
  }, [t]);

  useEffect(() => {
    if (data == null) {
      fetchTemperature();
      return;
    }

    ConvertToReadableTime(data.publishedAt);

    const interval = setInterval(() => {
      ConvertToReadableTime(data.publishedAt);
      if (lastMeasured >= 20) {
        setData(null);
      }
    }, 60000);

    return () => clearInterval(interval);
  }, [data, lastMeasured, fetchTemperature]);

  function ConvertToReadableTime(publishedDate) {
    var now = new Date();
    var nowUtcEpoch = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(),
      now.getUTCDate(), now.getUTCHours(),
      now.getUTCMinutes(), now.getUTCSeconds());

    var year = publishedDate.substring(0, publishedDate.indexOf("-"));
    publishedDate = publishedDate.slice(5, publishedDate.length)

    var month = publishedDate.substring(0, publishedDate.indexOf("-"));
    publishedDate = publishedDate.slice(3, publishedDate.length)

    var day = publishedDate.substring(0, publishedDate.indexOf("T"));
    publishedDate = publishedDate.slice(3, publishedDate.length)

    var time = publishedDate.substring(0, publishedDate.indexOf("."));

    var hour = time.substring(0, time.indexOf(":"));
    time = time.slice(3, time.length)

    var minutes = time.substring(0, time.indexOf(":"));

    var seconds = time.slice(3, time.length)

    var transformedDate = new Date(year, month - 1, day, hour, minutes, seconds);
    var transformedDateEpoch = Date.UTC(transformedDate.getFullYear(), transformedDate.getMonth(),
      transformedDate.getDate(), transformedDate.getHours(),
      transformedDate.getMinutes(), transformedDate.getSeconds());

    var diffMs = (nowUtcEpoch - transformedDateEpoch);

    var totalMinutesSinceUpdate = Math.floor((diffMs / 60000))

    setLastMeasured(totalMinutesSinceUpdate);
  }

  return (
    <div className="App">
      <div className="sky" aria-hidden="true">
        <div className="sun-glow" />
        <img className="sun" src="/sun.png" alt="" />
        <img className="palm palm-left" src="/beach.png" alt="" />
        <img className="palm palm-right" src="/beach.png" alt="" />
      </div>

      <div className="waves" aria-hidden="true">
        <svg className="wave wave-back" viewBox="0 0 1600 200" preserveAspectRatio="none">
          <path d="M0,100 C200,180 400,20 600,100 C800,180 1000,20 1200,100 C1400,180 1600,20 1800,100 L1800,200 L0,200 Z" />
        </svg>
        <svg className="wave wave-front" viewBox="0 0 1600 200" preserveAspectRatio="none">
          <path d="M0,120 C200,40 400,200 600,120 C800,40 1000,200 1200,120 C1400,40 1600,200 1800,120 L1800,200 L0,200 Z" />
        </svg>
      </div>

      <main className="content">
        <div className="card">
          {error ? (
            <div className="state state-error">
              <span className="state-icon">🐚</span>
              <p className="state-text">{error}</p>
              <button className="retry-button" onClick={fetchTemperature}>{t('retry')}</button>
            </div>
          ) : data == null ? (
            <div className="state state-loading">
              <div className="dot-wave">
                <span></span><span></span><span></span>
              </div>
              <p className="state-text">{t('loading')}</p>
            </div>
          ) : (
            <>
              <p className="eyebrow">🌊 {t('waterTemperature')}</p>
              <h1 className="temp">
                {data.data.temperature}<span className="degree">°C</span>
              </h1>
              <p className="meta">{t('lastMeasurement', { val: lastMeasured })}</p>
            </>
          )}
        </div>
      </main>
    </div>
  );
}

export default App;
